import './nexops.css';
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import SignaturePublique from './SignaturePublique';
import KmReminderPublic from './KmReminderPublic';

const root = ReactDOM.createRoot(document.getElementById('root'));
const signMatch = window.location.pathname.match(/^\/sign\/([a-f0-9a-f0-9]+)$/);
const kmMatch = window.location.pathname.match(/^\/km\/([a-f0-9]+)$/);

if (signMatch) {
  root.render(<SignaturePublique token={signMatch[1]} />);
} else if (kmMatch) {
  root.render(<KmReminderPublic token={kmMatch[1]} />);
} else {
  root.render(<React.StrictMode><App /></React.StrictMode>);
}
